import { RootState } from '../store';

export const selectContentType = (state: RootState) => state.onboarding.content_type;
export const selectGoal = (state: RootState) => state.onboarding.goal;
export const selectTone = (state: RootState) => state.onboarding.tone;
export const selectIndustry = (state: RootState) => state.onboarding.industry;
export const selectKind = (state: RootState) => state.onboarding.kind;
export const selectSuggestions = (state: RootState) => state.onboarding.suggestions;
export const selectTrendingTopics = (state: RootState) => state.onboarding.trendingTopics;
export const selectIsLoadingTrendingTopics = (state: RootState) =>
    state.onboarding.isLoadingTrendingTopics;
